module.exports = __webpack_public_path__ + "static/logo-e68dcf1ac82e6a91e127f76b5090f957.png";